import { apiFetcher } from './api'
import { ApiType } from 'utils/types'

type SocialLoginBeemParams = {
  beemUserId?: string
  promoCode?: string
}

function buildBeemQuery(params?: SocialLoginBeemParams) {
  const searchParams = new URLSearchParams()
  if (params?.beemUserId) searchParams.set('beemUserId', params.beemUserId)
  if (params?.promoCode) searchParams.set('promoCode', params.promoCode)
  const qs = searchParams.toString()
  return qs ? `?${qs}` : ''
}

export function postGoogle(token: string, beem?: SocialLoginBeemParams) {
  return apiFetcher<ApiType['PublicUserLoginResponse']>(`/api/v1/google${buildBeemQuery(beem)}`, {
    method: 'POST',
    headers: {
      token,
    },
  })
}

export function postFacebook(token: string, beem?: SocialLoginBeemParams) {
  return apiFetcher<ApiType['PublicUserLoginResponse']>(`/api/v1/facebook${buildBeemQuery(beem)}`, {
    method: 'POST',
    headers: {
      token,
    },
  })
}
